/* Copyright 2023 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/**
 * Returns a stringified version of the object, which recursively stringifies every key and value of the object.
 * @param object - the object to stringify
 */
export function objectToString(object:any) {
    if (object) {
        Object.keys(object).forEach(k => {
            if (typeof object[k] === 'object') {
              return objectToString(object[k]);
            }
            
            object[k] = '' + object[k];
          });
    }
    return object;
}